import { Link } from 'react-router-dom';

interface AuthBackLinkProps {
  to?: string;
}

/**
 * Back link for auth pages.
 */
export function AuthBackLink({ to = '/' }: AuthBackLinkProps) {
  return (
    <Link
      to={to}
      className="inline-flex items-center gap-2 text-gray-500 hover:text-gray-900 transition-colors"
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
      </svg>
      <span className="text-sm font-medium">Back</span>
    </Link>
  );
}
